import { TransactionDetails } from '../types/api.types';

// paymentActions.ts
export const SET_PAYMENT_DETAILS = 'SET_PAYMENT_DETAILS';
export const SET_INSTALLMENT_BINS = 'SET_INSTALLMENT_BINS';
export const SET_SELECTED_PLAN = 'SET_SELECTED_PLAN';
export const CLEAR_INSTALLMENT_DATA = 'CLEAR_INSTALLMENT_DATA';
export const RESTORE_ORIGINAL_AMOUNT = 'RESTORE_ORIGINAL_AMOUNT';

export const setPaymentDetails = (payload: TransactionDetails) => ({
  type: SET_PAYMENT_DETAILS,
  payload,
});

export const setInstallmentBins = (payload: any) => ({
  type: SET_INSTALLMENT_BINS,
  payload,
});

export const clearInstallmentData = () => ({
  type: CLEAR_INSTALLMENT_DATA,
});

export const setSelectedPlan = (payload: {
  selectedPlanId: string;
  providerKey: string;
  providerID : number;
}) => ({
  type: SET_SELECTED_PLAN,
  payload,
});

export const restoreOriginalAmount = () => ({
  type: RESTORE_ORIGINAL_AMOUNT,
});
